module.exports = __webpack_public_path__ + "img/2_145.9e628812.png";